import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { hasStandardEnhancedMenu } from '@shared/utils';
import { filter, map, Observable, switchMap, take } from 'rxjs';

/**
 * Guards the enquiry-based Quotes and Bookings list pages. Only suppliers on the
 * STANDARD_ENHANCED_MENU tier or above reach them; everyone else — standard and
 * Pro alike — is sent home, so the URLs behave as if the pages do not exist.
 */
@Injectable({ providedIn: 'root' })
export class EnquiryMigratedGuard implements CanActivate {
  constructor(
    private _featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._featureFlagService.getFlagsLoaded().pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this._featureFlagService.getFeatureFlags().pipe(take(1))),
      map(({ flags }) => {
        if (hasStandardEnhancedMenu(flags)) {
          return true;
        }

        return this.router.createUrlTree(['/']);
      })
    );
  }
}
